import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  justify-content: center;
  align-content: center;
  display: flex;
  padding: 32px;

  @media ${({ theme }) => theme.device.mobile} {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    z-index: 9;
    border-radius: 0;
    margin: 0;
    padding: 0;
    background-color: ${({ theme }) => theme.imagePicker.background};
  }
`;

export const Close = styled.img`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;

  @media ${({ theme }) => theme.device.mobile} {
    top: 30px;
  }
`;

export const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ZoomInput = styled.input`
  margin-top: 15px;
  -webkit-appearance: none;
  width: 100%;
  height: 5px;
  border-radius: 5px;
  background: ${ColorPalette.HEX.LightGray2};
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;

  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: ${ColorPalette.HEX.TartOrange};
    cursor: pointer;
  }
`;

export const ConfirmBtn = styled(Button)`
  height: 56px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 48px;
`;
